'use client';
import React from 'react';
import AppLayout from '@/components/AppLayout';
import BOMProjectsList from './components/BOMProjectsList';

export default function BOMPage() {
  return (
    <AppLayout currentPath="/bom">
      <BOMProjectsList />
    </AppLayout>
  );
}
